import React from "react";
import { Navigate } from "react-router-dom";
import { useUserGroups } from "../shared/hooks/useUserGroups";

/**
 * Role-aware landing: admins open the dashboard, associates the candidate
 * list, everyone else their profile. Rendered inside Authmiddleware, so the
 * user is already authenticated here.
 */
const Home = () => {
  const { isAdmin, isAssociate } = useUserGroups();
  const to = isAdmin ? "/admin/dashboard" : isAssociate ? "/candidatos" : "/profile";
  return <Navigate to={to} replace />;
};

export default Home;
